<script lang="ts">
  export let selectValue: (value: object) => void;
  export let selectedValue: object;
  export let values: object[] = [];
  export let key: string;

  $: selectedKey = selectedValue && selectedValue[key];

</script>

<style>
  .button-group > button:focus {
    outline: none;
    box-shadow: none;
  }

</style>

<div class="fizz-flex-row-0 fizz-flex-wrap button-group" style="--gap: 8px">
  {#each values as value}
    <button
      on:click={() => selectValue(value)}
      class={selectedKey === value[key] ? "fizz-button-secondary selected" : "fizz-button"}
    >
      {value[key]}
    </button>
  {/each}
</div>
